/* eslint-disable import/prefer-default-export */
import { Component, OnInit } from '@angular/core';
import { ContentDetailsService } from 'src/app/service-pool/content-details/content-details.service';
import { CookieService } from 'ngx-cookie';
import { ContentItem } from 'src/app/model/content-items.dto';
import { L10nTranslationService } from 'angular-l10n';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-pricing-grid',
  templateUrl: './pricing-grid.component.html',
  styleUrls: ['./pricing-grid.component.css'],
})
export class PricingGridComponent implements OnInit {
  pricingGridList: ContentItem[];

  brand: string;

  constructor(
    private contentDetailsService: ContentDetailsService,
    private cookieService: CookieService,
    private translationService: L10nTranslationService
  ) {}

  ngOnInit() {
    this.brand = this.cookieService.get('bid');
    this.translationService.onChange().subscribe(() => {
      this.contentDetailsService.clearContentCache();
      this.contentDetailsService.getContentForLS().subscribe(() => {
        this.updatePricingGridList();
      });
    });
  }

  pricingGridCreation(): ContentItem[] {
    const gridContent = this.contentDetailsService.getProgramContentByPosition('Pricing Bulletins');
    if (gridContent && gridContent.items) {
      return gridContent.items;
    }
    return [];
  }

  updatePricingGridList() {
    this.pricingGridList = this.pricingGridCreation();
    if (this.pricingGridList) {
      this.pricingGridList.sort((prev, curr) => prev.objectOrder - curr.objectOrder);
    }
  }
}
